import React from 'react'
import { Route, Switch } from 'react-router-dom'
import HeadersPage from '../components/Headers'
import BreadcrumbsPage from '../components/Breadcrumbs'
import Disclosure from '../components/Disclosure'
import Sidenav from '../components/Sidenav'
import TabGroupComponent from '../components/TabGroup'

const Navigation = (props: any) => {
  const { path } = props.match
  return (
    <Switch>
      <Route exact path={`${path}`} />
      <Route path={`${path}/header`}>
        <HeadersPage />
      </Route>
      <Route path={`${path}/breadcrumbs`}>
        <BreadcrumbsPage />
      </Route>
      <Route path={`${path}/disclosure`}>
        <Disclosure />
      </Route>
      <Route path={`${path}/sidenav`}>
        <Sidenav />
      </Route>
      <Route path={`${path}/tabgroup`}>
        <TabGroupComponent />
      </Route>

    </Switch>
  )
}

export default Navigation
